import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=ee2918ce&scoped=true&"
import script from "./PaymentSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=ee2918ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2918ce",
  null
  
)

export default component.exports